import http from '../../core/services/http'

export const generateCountsReport = () =>
  http.get(`/reports/counts`, { responseType: 'blob' })
